/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Alert, Button, Col, Row, Select } from "antd";
import MapPropsContext from "../MapPropsContext";
import { Title } from "./Common";
import { OPTION_MONTH, OPTION_YEAR } from "../../../utils";
import useInputs from "../../../utils/hooks/useInputs";
import moment from "moment";
import { TI_COMPARE_MONTH, TI_COMPARE_YEAR, TI_CRITERIA_MONTH, TI_CRITERIA_YEAR, TI_SEARCH_BUTTON } from "../../../Constants";

const WidgetSelectMonthDetail = () => {
  const { geojsonExtraParams, setGeojsonExtraParams, setChartDivVisible } = useContext(MapPropsContext);

  // // selectbox에서 year month 변화 체크
  const { checkStartYear, checkStartMonth, checkEndYear, checkEndMonth } = geojsonExtraParams;
  const [errorMessage, setErrorMessage] = useState();

  const [inputsState, onChange] = useInputs({
    checkStartYear,
    checkStartMonth,
    checkEndYear,
    checkEndMonth,
  });

  useEffect(() => {
    const { checkStartYear, checkStartMonth, checkEndYear, checkEndMonth } = inputsState;
    const start = moment(`${checkStartYear}-${checkStartMonth}`, ["YYYY-MM"]);
    const end = moment(`${checkEndYear}-${checkEndMonth}`, ["YYYY-MM"]);
    const diffMonths = end.diff(start, "months");

    if (diffMonths < 0) {
      setChartDivVisible(false);
      setErrorMessage("검색조건의 기준년월이 비교년월보다 이후일 수 없습니다.");
    } else if (diffMonths > 24) {
      setChartDivVisible(false);
      setErrorMessage("검색조건의 기준년월이 비교년월보다 24개월을 초과할 수 없습니다.");
    } else {
      setErrorMessage(null);
    }
  }, [inputsState]);

  const doSearch = useCallback(() => {
    const { checkStartYear, checkStartMonth, checkEndYear, checkEndMonth } = inputsState;
    setGeojsonExtraParams((prev) => ({
      ...prev,
      checkStartYear,
      checkStartMonth,
      checkEndYear,
      checkEndMonth,
    }));
    setChartDivVisible(true);
  }, [inputsState, setGeojsonExtraParams]);

  return (
    <div>
      <Title style={{ marginTop: 4 }}>기준년월</Title>
      <Row>
        <Col span={14}>
          <Select
            value={inputsState.checkStartYear}
            tabIndex={TI_CRITERIA_YEAR}
            onChange={(value) => onChange({ target: { name: "checkStartYear", value: Math.floor(value) } })}
            style={{ width: "100%" }}
          >
            {OPTION_YEAR().map(({ value }) => (
              <Select.Option value={value} key={value}>
                {value}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={9} offset={1}>
          <Select
            tabIndex={TI_CRITERIA_MONTH}
            value={inputsState.checkStartMonth}
            onChange={(value) => onChange({ target: { name: "checkStartMonth", value: Math.floor(value) } })}
            style={{ width: "100%" }}
          >
            {OPTION_MONTH().map(({ value }) => (
              <Select.Option value={value} key={value}>
                {value}
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>

      <Title style={{ marginTop: 4 }}>비교년월</Title>
      <Row>
        <Col span={14}>
          <Select
            tabIndex={TI_COMPARE_YEAR}
            value={inputsState.checkEndYear}
            onChange={(value) => onChange({ target: { name: "checkEndYear", value: Math.floor(value) } })}
            style={{ width: "100%" }}
          >
            {OPTION_YEAR().map(({ value }) => (
              <Select.Option value={value} key={value}>
                {value}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={9} offset={1}>
          <Select
            tabIndex={TI_COMPARE_MONTH}
            value={inputsState.checkEndMonth}
            onChange={(value) => onChange({ target: { name: "checkEndMonth", value: Math.floor(value) } })}
            style={{ width: "100%" }}
          >
            {OPTION_MONTH().map(({ value }) => (
              <Select.Option value={value} key={value}>
                {value}
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>

      {errorMessage && <Alert message={errorMessage} type={"error"} style={{ marginTop: 8 }} />}

      <Button
        type={"primary"}
        disabled={!!errorMessage}
        onClick={doSearch}
        style={{ width: "100%", marginTop: 8 }}
        tabIndex={TI_SEARCH_BUTTON}
      >
        검색
      </Button>
    </div>
  );
};

export default WidgetSelectMonthDetail;
